import React from 'react';
import { useNavigate } from 'react-router-dom';
import RegistroEstudianteForm from '../../components/registro/RegistroEstudianteForm';

/**
 * Página principal de registro de estudiantes
 * Ruta pública accesible sin autenticación
 */
const RegistroEstudiantes = () => {
  const navigate = useNavigate();

  const handleRegistroExitoso = (datosEstudiante) => {
    // Redirigir a página de confirmación o home
    navigate('/registro-confirmacion', { 
      state: { datosEstudiante },
      replace: true 
    });
  };

  return (
    <RegistroEstudianteForm onRegistroExitoso={handleRegistroExitoso} />
  );
};

export default RegistroEstudiantes;
